import { Directive, ElementRef, HostBinding, inject, OnDestroy, OnInit } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';

@Directive({
    selector: 'ng-select[cmsNgSelect], ng-select[exerciseNgSelect]',
    standalone: false,
    host: {
        class: 'cms-ng-select exercise-ng-select',
    },
})
export class CmsNgSelectDirective implements OnInit, OnDestroy {
    private readonly ngSelect = inject(NgSelectComponent);
    private readonly element = inject(ElementRef<HTMLElement>);

    private readonly onMouseDownCapture = (event: MouseEvent): void => {
        const target = event.target as HTMLElement;
        if (!target.closest('.ng-select-container')) {
            return;
        }

        if (target.closest('.ng-value-icon')) {
            return;
        }

        if (this.ngSelect.isOpen()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.ngSelect.close();
        }
    };

    ngOnInit(): void {
        this.element.nativeElement.addEventListener('mousedown', this.onMouseDownCapture, true);
    }

    ngOnDestroy(): void {
        this.element.nativeElement.removeEventListener('mousedown', this.onMouseDownCapture, true);
    }
}

@Directive({
    selector: 'ng-select[cmsNgSelectMulti], ng-select[exerciseNgSelectMulti]',
    standalone: false,
})
export class CmsNgSelectMultiDirective {
    @HostBinding('closeOnSelect') closeOnSelect = false;
    @HostBinding('clearable') clearable = false;
}

@Directive({
    selector: 'ng-select[exerciseNgSelectMenuSearch], ng-select[cmsNgSelectMenuSearch]',
    standalone: false,
    host: {
        class: 'exercise-ng-select--menu-search',
        '[searchable]': 'false',
    },
})
export class CmsNgSelectMenuSearchDirective {}
